import graphql from './graphql';
import JobTitleList from './Request/JobTitle_list';
import { getOptionalCourses } from './axios/optional-courses-api';

const fetch = async () => {
  const promises = [];
  let jobTitleTotalCourses = 0;

  promises.push(JobTitleList({ statusFilter: 'ACTIVE' }));
  promises.push(graphql('Course_countByEnterprise', 'count', 'query'));
  promises.push(graphql('Course_countByDepartment', 'count', 'query'));
  promises.push(getOptionalCourses());

  const data = await Promise.all(promises);
  const puestos = data[0];

  if (!puestos) {
    return null;
  }

  if (puestos.length > 0) {
    puestos.forEach(jobTitle => {
      jobTitleTotalCourses += jobTitle.numberOfCourses;
    });
  }

  const countByJobTitle = jobTitleTotalCourses;
  const countByEnterprise = data[1].Course_countByEnterprise.count;
  const countByDepartment = data[2].Course_countByDepartment.count;
  // getOptionalCourses trae el catálogo completo; la tarjeta cuenta solo los
  // marcados, con la misma regla que la pantalla en lote: alcance 'all'.
  const countOptional = data[3].data.filter(course => course.isOptional && course.optionalScope === 'all').length;

  return { countByJobTitle, countByEnterprise, countByDepartment, countOptional };
};
export default fetch;
